{
  "$id": "skill-frontmatter",
  "type": "object",
  "additionalProperties": false,
  "required": [
    "name",
    "description",
    "model_tier",
    "cacheable",
    "cache_key_inputs",
    "output_format",
    "input_schema"
  ],
  "anyOf": [{ "required": ["triggers"] }, { "required": ["request_routing"] }],
  "properties": {
    "name": { "type": "string", "minLength": 1 },
    "description": { "type": "string", "minLength": 1 },
    "model_tier": { "type": "string", "enum": ["fast", "medium", "reasoning", "deep"] },
    "triggers": { "type": "array", "minItems": 1 },
    "request_routing": {
      "type": "array",
      "minItems": 1,
      "items": {
        "type": "object",
        "additionalProperties": false,
        "required": ["priority", "patterns", "target_workflow"],
        "properties": {
          "priority": { "type": "integer", "minimum": 1 },
          "patterns": {
            "type": "array",
            "minItems": 1,
            "items": { "type": "string", "minLength": 1 }
          },
          "target_workflow": {
            "anyOf": [
              {
                "type": "string",
                "enum": [
                  "project-question",
                  "ticket-refinement",
                  "writing",
                  "editing",
                  "planning",
                  "research",
                  "feature-development",
                  "bug-fix",
                  "refactor",
                  "migration",
                  "content-update",
                  "investigation",
                  "cleanup",
                  "architecture-change",
                  "test-improvement",
                  "documentation-update",
                  "root-cause-analysis",
                  "pentest",
                  "pentest-retest",
                  "schema-change",
                  "query-optimization",
                  "custom"
                ]
              },
              {
                "type": "string",
                "pattern": "^custom:.+"
              }
            ]
          }
        }
      }
    },
    "max_lines": { "type": "integer", "maximum": 300 },
    "cacheable": { "type": "boolean" },
    "cache_key_inputs": { "type": "array", "items": { "type": "string" } },
    "output_format": { "type": "string", "enum": ["markdown", "yaml", "json"] },
    "input_schema": {
      "type": "object",
      "minProperties": 1,
      "additionalProperties": {
        "type": "object",
        "additionalProperties": false,
        "required": ["type", "required"],
        "properties": {
          "type": {
            "type": "string",
            "enum": ["string", "string[]", "boolean", "path", "path[]", "object"]
          },
          "required": { "type": "boolean" },
          "description": { "type": "string", "minLength": 1 }
        }
      }
    },
    "on_complete": {
      "type": "object",
      "additionalProperties": false,
      "required": ["emit", "triggers"],
      "properties": {
        "emit": { "type": "string", "minLength": 1 },
        "triggers": { "type": "array", "minItems": 1, "items": { "type": "string" } }
      }
    },
    "tools": { "type": "array", "items": { "type": "string" } }
  }
}
